"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var textareaAutosizeInputStyles = makeStyles_1.default(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        container: {
            whiteSpace: 'pre-wrap',
        },
        root: {
            background: palette.common.white,
            width: '100%',
            padding: '8px',
            outline: 'none',
            resize: 'none',
            border: "1px solid " + palette.primary.light,
            lineHeight: 2,
            minHeight: 40,
            borderRadius: 0,
            '&:hover': {
                borderColor: palette.primary.main,
            },
            '&:focus': {
                borderColor: palette.primary.main,
            },
            '&::placeholder': {
                textTransform: 'initial',
                lineHeight: 2,
                fontSize: typography.caption.fontSize,
                opacity: 0.5,
            },
        },
    });
}, { name: 'GqlCheckout_TextareaAutosizeInput' });
exports.default = textareaAutosizeInputStyles;
